import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllMenu () {
    return axios.post(global.BASE_ACL + '/menu/findAllMenu')
  },
  findAllMenuUrl (param) {
    return axios.post(global.BASE_ACL + '/menu/findAllUrl', param)
  },
  findMenuBySystemId (param) {
    return axios.post(global.BASE_ACL + '/menu/findMenuBySystemId', param)
  },
  menufindById (params) {
    return axios.post(global.BASE_ACL + '/menu/findMenuById', params)
  },
  menuDelete (params) {
    return axios.post(global.BASE_ACL + '/menu/deleteMenu', params)
  },
  menufindByCondition (params) {
    return axios.post(global.BASE_ACL + '/menu/findMenuByCondition', params)
  },
  menuInsert (params) {
    return axios.post(global.BASE_ACL + '/menu/insertMenu', params)
  },
  menuUpadte (params) {
    return axios.post(global.BASE_ACL + '/menu/updateMenu', params)
  },
  menuFindWhenUpdate (params) {
    return axios.post(global.BASE_ACL + '/menu/findWhenUpdate', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/syssetting/menuList.js